<div class="ud-dialog">
  <div class="ud-header">
    <div class="ud-title-wrap">
      <div class="ud-title-icon"><mat-icon>manage_accounts</mat-icon></div>
      <div><h2 class="ud-title">Edit user</h2><div class="ud-subtitle">Update this team member’s profile details</div></div>
    </div>
    <button mat-icon-button mat-dialog-close class="ud-close" [disabled]="userSaveClick" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>
  <form id="saveUser" class="ud-body" (ngSubmit)="saveUser()">
    <div class="ud-field">
      <label class="ud-label">Display name <span class="ud-required">*</span></label>
      <mat-form-field appearance="outline" class="ud-mat"><input matInput placeholder="Display name" name="displayName" required [(ngModel)]="user.displayName"></mat-form-field>
    </div>
    <div class="ud-field">
      <label class="ud-label">Email address <span class="ud-required">*</span></label>
      <mat-form-field appearance="outline" class="ud-mat"><input matInput placeholder="name@company.com" type="email" name="email" required [(ngModel)]="user.emailAddress"></mat-form-field>
      <p class="ud-help">Changing the email updates the address this user signs in with.</p>
    </div>
  </form>
  <div class="ud-footer">
    <button mat-button mat-dialog-close class="ud-btn-ghost" [disabled]="userSaveClick">Cancel</button>
    <button type="submit" form="saveUser" class="ud-btn-primary" [disabled]="userSaveClick">
      @if (userSaveClick) { <mat-spinner diameter="20" strokeWidth="3"></mat-spinner> } @else { <span>Save changes</span><mat-icon>check</mat-icon> }
    </button>
  </div>
</div>
